module.exports = __webpack_public_path__ + "static/media/transfer_miles_gray.2de59c35.svg";